import { makeAutoObservable } from 'mobx';
import ILead from '../interfaces/ILead';

export default class RecordedSaleStore {
    recordedSales: ILead[] = [];

    constructor() {
        makeAutoObservable(this);
    }

    setRecordedSales(recordedSales: ILead[]) {
        this.recordedSales = recordedSales;
    }

    clear() {
        this.setRecordedSales([]);
    }
}